module.exports = __webpack_public_path__ + "assets/img/ad4.668839e8.svg";